function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNftTradeIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 18,
    rx: 6,
    ry: 6,
    style: {
      fill: "#ff7a87",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.18,5.32l-2.69-1.56c-.61-.34-1.52-.35-2.13,0l-2.73,1.58c-1.11,.75-1.27,.94-1.27,2.24v2.83c0,1.3,.16,1.5,1.31,2.27l2.68,1.55c.31,.18,.69,.26,1.07,.26s.77-.09,1.07-.26l2.73-1.58c1.11-.75,1.27-.94,1.27-2.24v-2.83c0-1.3-.16-1.5-1.3-2.26Zm-.02,5.09q0,.69-.64,1.13l-2.69,1.55c-.2,.11-.61,.11-.81,0l-2.65-1.53q-.69-.46-.69-1.14v-2.83q0-.69,.65-1.13l2.68-1.55c.11-.05,.26-.09,.4-.09s.31,.04,.4,.09l2.65,1.53q.69,.46,.69,1.14v2.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.77,9.16l-.25,.3,.03,.38c.01,.22-.07,.4-.22,.51-.09,.07-.19,.1-.31,.1-.08,0-.16-.02-.25-.05l-.36-.15-.36,.15c-.19,.07-.4,.06-.55-.05-.15-.11-.23-.3-.22-.51l.02-.38-.25-.3c-.14-.17-.18-.36-.13-.54,.06-.18,.21-.31,.42-.36l.38-.1,.21-.33c.12-.18,.32-.28,.48-.28,.18,0,.36,.1,.47,.28l.21,.33,.37,.09c.21,.05,.36,.18,.42,.36,.06,.18,.02,.37-.12,.54Z",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.23,12.58s-.04,0-.05,0c-.15-.01-.29-.07-.41-.15-.04-.03-.08-.06-.11-.1-.11-.13-.18-.3-.18-.48h0V7.59c0-.41,.34-.75,.75-.75s.75,.34,.75,.75v2.43l4.38-4.38c.29-.29,.77-.29,1.06,0s.29,.77,0,1.06l-4.38,4.38h2.43c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75h-4.24Z",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftTradeIn);
export default __webpack_public_path__ + "static/media/NFT_trade_in.66d1720a626ca53bf240ecc1fbf1586f.svg";
export { ForwardRef as ReactComponent };